import { useQuery } from '@tanstack/react-query';
import { Route } from '../../../routes/articles.$slug';
import {
  articleShowQuery,
  emptySidebarData,
  isSlugRedirect,
  sidebarQuery,
} from '../../../lib/queries';
import { articleUrl, shortUrl } from '../../../lib/seo';
import { Sidebar } from '../../home/components/Sidebar';
import { ArticleHeader } from '../components/ArticleHeader';
import { ArticleAuthorRow } from '../components/ArticleAuthorRow';
import { ArticleBody } from '../components/ArticleBody';
import { ArticleTags } from '../components/ArticleTags';
import { ArticleReader } from '../components/ArticleReader';
import { RelatedNews } from '../components/RelatedNews';
import { NewsletterBox } from '../components/NewsletterBox';
import { ArticleAd } from '../components/ArticleAd';
import { ArticleSocialFollow } from '../components/ArticleSocialFollow';


export function ArticleShowPage() {
  const { slug } = Route.useParams();
  const {
    data: show,
    isLoading: isArticleLoading,
    isError: isArticleError,
  } = useQuery({
    ...articleShowQuery(slug),
    enabled: slug.length > 0,
  });
  const { data: sidebar = emptySidebarData } = useQuery({
    ...sidebarQuery(),
    placeholderData: emptySidebarData,
  });

  if (isArticleError) {
    return <ArticleStatus message="تعذر تحميل المقال حالياً." />;
  }

  // The loader turns a retired slug into a 301 before this renders, so the
  // redirect payload should never reach here — but rendering it threw
  // `can't access property "slug"`, so it is guarded rather than assumed away.
  if (isArticleLoading || !show || isSlugRedirect(show)) {
    return <ArticleStatus message="جاري تحميل المقال..." />;
  }

  const { article, previous, next, related, tags } = show;
  const url = articleUrl(article.slug);
  // Shares carry the short link: it stays valid across slug edits and does not
  // blow past message-length limits the way a percent-encoded Arabic slug does.
  const share = shortUrl(article.shortCode, article.slug);
  return (
    <>
      <section className="post-layout-1-area pb-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="post-layout-top-content">
                <ArticleHeader article={article} />
                <ArticleAuthorRow
                  url={url}
                  shareUrl={share}
                  title={article.title}
                  publishedAt={article.publishedAt}
                />
                <ArticleBody html={article.html} />
                <ArticleTags tags={tags} />
                <ArticleReader previous={previous} next={next} />
              </div>
            </div>
            <div className="col-lg-4">
              <Sidebar
                newest={sidebar.newest}
                trending={sidebar.trending}
                economy={sidebar.economy}
              />
              <ArticleSocialFollow />
              <ArticleAd />
              <NewsletterBox />
            </div>
          </div>
        </div>
      </section>
      <RelatedNews items={related} />
    </>
  );
}

function ArticleStatus({ message }: { message: string }) {
  return (
    <section className="post-layout-1-area pb-5">
      <div className="container">
        <div
          className="text-center py-5"
          style={{
            padding: '48px 16px',
            color: '#6c757d',
            fontSize: 14,
            border: '1px dashed #dee2e6',
            borderRadius: 8,
            background: '#f8f9fa',
          }}
        >
          {message}
        </div>
      </div>
    </section>
  );
}
